/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { CityVizComponentDisplay } from "./display";
import { CityVizComponentEditor } from "./edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function CityVizComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <CityVizComponentDisplay />,
        editComponent: <CityVizComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

CityVizComponent.displayName = "CityVizComponent";
export { CityVizComponent };
